import { render } from "./MailsSection.vue?vue&type=template&id=ac9398ba&scoped=true"
import script from "./MailsSection.vue?vue&type=script&lang=js"
export * from "./MailsSection.vue?vue&type=script&lang=js"

import "./MailsSection.vue?vue&type=style&index=0&id=ac9398ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac9398ba"]])

export default __exports__